export default __webpack_public_path__ + "static/media/google_on_white_hdpi.68f88d82.png";